import { useQuery } from "@tanstack/react-query";
import { findRevuesNumeriquesForUser } from "../services/revues-numeriques.service";
import { ksRevuesNumeriquesQK } from "../query-keys";

export const useRevuesNumeriques = () =>
  useQuery({
    queryKey: [ksRevuesNumeriquesQK],
    queryFn: findRevuesNumeriquesForUser,
  });
